/**
 * Wrapper de localStorage com try/catch.
 *
 * Em certos contextos o browser **nega acesso** a localStorage e o simples
 * acesso a `window.localStorage` (ou a `.getItem/.setItem`) lança
 * `SecurityError: Access is denied for this document`:
 * - in-app browser (WhatsApp / Instagram / Facebook), WebView
 * - Chrome com "dados de site de terceiros" bloqueados / storage particionado
 * - modos de privacidade restritos
 *
 * Sem esse wrapper o app inteiro crashava (Sentry BOLAO-ELITE-5):
 * `AuthContext` lê o token no boot e o fluxo de convite `/join` usa storage
 * — exatamente onde as pessoas clicam (link compartilhado dentro do
 * WhatsApp/Instagram, que abre no in-app browser).
 *
 * Comportamento **idêntico** ao localStorage quando disponível (caso 99%).
 * Quando bloqueado, degrada graciosamente: get → `null`, set/remove → no-op.
 * Retrocompatível: mesma API (`getItem`/`setItem`/`removeItem`).
 */
export const safeStorage = {
  getItem(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      /* storage bloqueado — no-op (degradação graciosa) */
    }
  },
  removeItem(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* storage bloqueado — no-op */
    }
  },
};
